import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  EUROCOUPONS_COUPON(state, euroCouponsCoupon) {
    state.cached = euroCouponsCoupon
  },
}

export const actions = {

  init({ state, dispatch }) { },

  fetchEuroCouponsCoupon(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/coupon/${query}`).then((response) => {
      const request = response.data
      context.commit('EUROCOUPONS_COUPON', request)
      return request
    })
  },

  fetchEuroCouponsCouponOptions(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/coupon/options/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroCouponsCouponRedeemed(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_coupons/coupon/redeemed/${query}`).then((response) => {
      return response.data
    })
  },

  fetchEuroCouponsCouponDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateEuroCouponsCoupon(context, formData) {
    let promise = null
    if (formData.url) {
      promise = axios.put(formData.url, formData)
    } else {
      promise = axios.post(`${serverUrl}/euro_coupons/coupon/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  RedeemEuroCouponsCoupon(context, formData) {
    let promise = null
    if (formData.url) {
      promise = axios.put(formData.url, formData)
    } else {
      console.log(formData.is_internal)
      if (formData.is_internal) {
        promise = axios.post(`${serverUrl}/euro_coupons/coupon/redeem_coupon_partial/`, formData)
      } else {
        promise = axios.post(`${serverUrl}/euro_coupons/coupon/redeem_coupon/`, formData)
      }

    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },




  checkEuroCouponsCoupon(context, query) {
    let promise = null
    promise = axios.get(`${serverUrl}/euro_coupons/coupon/check_coupon/${query}`)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  approveInactiveEuroCouponsCoupon(context, payload) {
    let promise = axios.post(`${serverUrl}/euro_coupons/coupon/approve_inactive_coupons/`, payload)
    if (payload.action == "send_message") {
      promise = axios.post(`${serverUrl}/euro_coupons/coupon/send_messages/`, payload)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },


  setCxcEuroCouponsCoupon(context, formData) {
    let promise = axios.post(`${serverUrl}/euro_coupons/coupon/set_cxc/`, formData)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  deleteEuroCouponsCoupon(context, permUrl) {
    let promise = null
    promise = axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  fetchDownloadCouponsReport(context, payload) {
    return axios.get(`${serverUrl}/euro_coupons/coupon/get_report/${payload.query}`, payload.type).then((response) => {
      return response
    })
  },

  fetchRedeemedReport(context, payload) {
    return axios.get(`${serverUrl}/euro_coupons/coupon/redeemed_report/${payload.query}`, payload.type).then((response) => {
      return response
    })
  },
}